import { render, staticRenderFns } from "./TrendingPostsTile.vue?vue&type=template&id=71f9779f"
import script from "./TrendingPostsTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingPostsTile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLtkImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkImg/CLtkImg.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,TrackPostImpression: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Track/TrackPostImpression.vue').default})
